export enum WithHistoryTypes {
  REMEMBER_STATE = "@@WITH_HISTORY/REMEMBER_STATE",
  UNDO = "@@WITH_HISTORY/UNDO",
  REDO = "@@WITH_HISTORY/REDO",
  RESET = "@@WITH_HISTORY/RESET",
  SET_INITIAL_STATE = "@@WITH_HISTORY/SET_INITIAL_STATE",
}
